export const FilterNameMapping = {
  news: {
    aiEntities: 'ai_entity_id',
    analysisCodes: 'analysis_code_id',
    customTagGroups: 'custom_tag_group_id',
    customTags: 'custom_tag_id',
    emojis: 'emoji',
    entities: 'entity_name',
    entitiesPerson: 'entity_person_name',
    entitiesOrganization: 'entity_organization_name',
    entitiesTopic: 'entity_topic_name',
    entitiesProduct: 'entity_product_name',
    entitiesLocation: 'entity_location_name',
    groupedStatementCodes: 'grouped_statement_code_id',
    hashtags: 'hashtag',
    identities: 'identity_id',
    iptcMediaTopics: 'iptc_media_topic_ids',
    languages: 'language_id',
    mediaReviewCodes: 'mediareview_code_id',
    mediaReviewTypes: 'media_review_type_id',
    mediaTopics: 'media_topic_id',
    mentions: 'mention',
    newsStatementTonalities: 'news_statement_tonality',
    pageIdentities: 'page_identity_id',
    publications: 'publication_id',
    postTypes: 'post_type',
    sentiments: 'sentiment',
    statementCodes: 'statement_code_id',
    tonalities: 'tonality',
    outlinks: 'outlink_id',
    domains: 'domain',
    interfaces: 'interface_id',
    suppliers: 'supplier_id',
    promoCodes: 'promo_code_id',
    gaioPrompts: 'gaio_prompt_id',
    gaioProjects: 'gaio_project_id',
    gaioPromptsCountries: 'gaio_prompts_countries',
    gaioPromptsLanguages: 'gaio_prompts_languages',
    gaioPromptsModelsPublications: 'gaio_prompts_models',
    personas: 'persona_id',
    analysis: {
      selectedCodes: 'selected_code_ids',
      restrictedCodes: 'restricted_code_ids',
      excludedCodes: 'excluded_code_ids',
      groupedCodes: 'grouped_code_ids',
      statementTonalities: 'statement_tonalities'
    },
    similarity: {
      ccdContents: 'ccd_content_ids',
      ccdCampaigns: 'ccd_campaign_ids'
    }
  },
  publication: {
    channels: 'channel_id',
    countries: 'country_id',
    distributionAreas: 'distribution_area_ids',
    filterGroups: 'filter_group_ids',
    mediaTypes: 'media_type_id',
    newsguardRanks: 'newsguard_rank',
    newsguardOrientations: 'newsguard_orientation_id',
    newsguardScoreRanges: 'newsguard_score_range',
    states: 'state_id'
  },
  pageIdentity: {
    identitySets: 'identity_set_ids'
  },
  outlink: {
    outlinkDomains: 'domain',
    outlinkUrls: 'url'
  }
}

export const NewsPageViews = {
  NEWS: 'news',
  BACKWARDS_NEWS: 'backwards_news',
  INFLUENCERS: 'influencers',
  PUBLICATIONS: 'publications',
  CHARTS: 'charts',
  SOURCES: 'sources',
  PIN_BOARDS: 'pin_boards',
  STATISTICS: 'statistics',
  PROFILES: 'profiles',
  POSTS: 'posts',
  SAVED_SEARCHES: 'saved_searches',
  STATIC_CHARTS: 'static_charts',
  ANALYSIS_QUERIES: 'analysis_queries'
}

export const NewsPageModules = {
  NEWS: 'news',
  ANALYSIS: 'analysis',
  PROFILE_MONITORING: 'profile_monitoring',
  NEWS_POOL: 'news_pool',
  GAIO: 'gaio'
}

export const GaioSubscriptionPlans = [
  {
    id: 'start',
    name: 'GEO Start',
    price: '199 €',
    projects: '1',
    promptExecutions: '2.000',
    monitoringUnits: 20,
    availableModelsLimit: 3
  },
  {
    id: 'growth',
    name: 'GEO Growth',
    price: '599 €',
    projects: '3',
    promptExecutions: '8.000',
    monitoringUnits: 60,
    availableModelsLimit: 4
  },
  {
    id: 'professional',
    name: 'GEO Professional',
    price: '1.590 €',
    projects: '10',
    promptExecutions: '21.000',
    monitoringUnits: 150,
    availableModelsLimit: 5
  }
]

export const CustomTagsNewsTypes = {
  [NewsPageModules.NEWS_POOL]: 'backwards_news',
  [NewsPageModules.NEWS]: 'default',
  [NewsPageModules.ANALYSIS]: 'default',
  [NewsPageModules.GAIO]: 'default',
  [NewsPageModules.PROFILE_MONITORING]: 'default'
}

export const NewsPageViewTypes = {
  LISTVIEW: 'list_view',
  CARDVIEW: 'card_view'
}

export const DefaultExportFormats = ['pdf', 'xlsx', 'html', 'txt', 'xml', 'xml_pure', 'json', 'json_pure']

export const InitialRoutes = {
  DASHBOARD: '/app/dashboard',
  NEWSBOARD: '/app/news',
  GEO_ANALYSIS: '/app/geo_analysis',
  PROFILE_MONITORING: '/app/profile_monitoring',
  SEARCH_POOL: '/app/search_pool',
  MEDIA_MONITORING: '/app/media_monitoring',
  MEDIA_REVIEWS: '/app/media_reviews',
  CONTENT_DESK: '/app/content_desk/content_management',
  CONTACT_MANAGEMENT: '/app/contact_management/contacts',
  JOURNALIST_SEARCH: '/app/contact_management/journalist_search',
  THEMAX: '/app/themax'
}

export const DateTypes = {
  ARTICLE: 'article',
  MEDIA_REVIEW: 'mediareview'
}

export const KeyFigures = {
  BUZZ: 'buzz',
  INTERACTIONS: 'interactions',
  INTERACTION_RATE: 'interaction_rate',
  REACH: 'reach',
  CHANNEL_KEY_FIGURES: 'channelKeyFigures',
  TOP_NEGATIVE_SENTIMENT: 'top_negative_sentiment',
  TOP_POSITIVE_SENTIMENT: 'top_positive_sentiment'
}

export const AllowedKeyFigures = {
  DEFAULT: [
    KeyFigures.BUZZ,
    KeyFigures.REACH,
    KeyFigures.INTERACTIONS,
    KeyFigures.INTERACTION_RATE,
    KeyFigures.CHANNEL_KEY_FIGURES
  ],
  BACKWARDS_NEWS: [
    KeyFigures.BUZZ,
    KeyFigures.REACH,
    KeyFigures.INTERACTIONS,
    KeyFigures.INTERACTION_RATE,
    KeyFigures.CHANNEL_KEY_FIGURES,
    KeyFigures.TOP_NEGATIVE_SENTIMENT,
    KeyFigures.TOP_POSITIVE_SENTIMENT
  ]
}

export const SearchFields = {
  AI_ENTITIES: 'aiEntities',
  AUTHOR_QUERIES: 'authorQueries',
  ANALYSIS_CODES: 'analysisCodes',
  BOOLEANS: 'booleans',
  CHANNELS: 'channels',
  COUNTRIES: 'countries',
  CUSTOM_TAGS: 'customTags',
  CUSTOM_TAG_GROUPS: 'customTagGroups',
  DISTRIBUTION_AREAS: 'distributionAreas',
  DOMAINS: 'domains',
  OUTLINKS: 'outlinks',
  OUTLINK_DOMAINS: 'outlinkDomains',
  OUTLINK_URLS: 'outlinkUrls',
  EMOJIS: 'emojis',
  ENTITIES: 'entities',
  ENTITIES_PERSON: 'entitiesPerson',
  ENTITIES_ORGANIZATION: 'entitiesOrganization',
  ENTITIES_TOPIC: 'entitiesTopic',
  ENTITIES_PRODUCT: 'entitiesProduct',
  ENTITIES_LOCATION: 'entitiesLocation',
  EXCLUDE_RETWEETS: 'excludeRetweets',
  EXCLUDE_REELS: 'excludeReels',
  EXCLUDE_STORIES: 'excludeStories',
  EXCLUDE_VISITOR_POSTS: 'excludeVisitorPosts',
  EXCLUDE_COMMENTS: 'excludeComments',
  COMMENTS_ONLY: 'commentsOnly',
  RETWEETS_ONLY: 'retweetsOnly',
  REELS_ONLY: 'reelsOnly',
  STORIES_ONLY: 'storiesOnly',
  VISITOR_POSTS_ONLY: 'visitorPostsOnly',
  FILTER_GROUPS: 'filterGroups',
  GEO_BOUNDING_BOX: 'geoBoundingBox',
  GLOBAL_CLUSTERS: 'globalClusters',
  HASHTAGS: 'hashtags',
  MENTIONS: 'mentions',
  IDENTITIES: 'identities',
  IDENTITY_SETS: 'identitySets',
  INFLUENCERS: 'influencers',
  INTERFACES: 'interfaces',
  SUPPLIERS: 'suppliers',
  PROMO_CODES: 'promoCodes',
  GAIO_PROMPTS: 'gaioPrompts',
  GAIO_PROJECTS: 'gaioProjects',
  GAIO_PROMPTS_COUNTRIES: 'gaioPromptsCountries',
  GAIO_PROMPTS_LANGUAGES: 'gaioPromptsLanguages',
  GAIO_PROMPTS_MODELS: 'gaioPromptsModelsPublications',
  PERSONAS: 'personas',
  LANGUAGES: 'languages',
  MEDIA_REVIEW_CODES: 'mediaReviewCodes',
  MEDIA_REVIEW_TYPES: 'mediaReviewTypes',
  MEDIA_TOPICS: 'mediaTopics',
  MEDIA_TYPES: 'mediaTypes',
  NEWS_QUERIES: 'newsQueries',
  PAGE_IDENTITIES: 'pageIdentities',
  PUBLICATION_QUERIES: 'publicationQueries',
  PUBLICATIONS: 'publications',
  SENTIMENTS: 'sentiments',
  SIMILARITY_CCD_CONTENTS: 'similarityCcdContents',
  SIMILARITY_CCD_CAMPAIGNS: 'similarityCcdCampaigns',
  SUMMARIZED_ONLY: 'summarizedOnly',
  TONALITIES: 'tonalities',
  ANALYSIS: 'analysis',
  STATEMENT_CODES: 'statementCodes',
  GROUPED_STATEMENT_CODES: 'groupedStatementCodes',
  NEWS_STATEMENT_TONALITIES: 'newsStatementTonalities',
  NEWSGUARD_RANKS: 'newsguardRanks',
  NEWSGUARD_ORIENTATIONS: 'newsguardOrientations',
  POST_TYPES: 'postTypes',
  WITH_OUTLINKS_ONLY: 'withOutlinksOnly',
  WITHOUT_OUTLINKS_ONLY: 'withoutOutlinksOnly',
  STATES: 'states'
}

export const DarknetSearchFields = {
  DARKNET_SEARCH_QUERIES: 'darknetSearchQueries',
  MIN_HACKISHNESS: 'minHackishness',
  NETWORKS: 'networks'
}

export const SearchFieldGroups = {
  NEWS: 'news',
  INFLUENCERS: 'influencers',
  PUBLICATIONS: 'publications'
}

export const IndexTypes = {
  DEFAULT: 'default',
  BACKWARDS_NEWS: 'backwards_news'
}

export const GroupingTypes = {
  CHANNEL: 'channel',
  MEDIA_REVIEW_CODE: 'media_review_code',
  CUSTOM_TAG: 'custom_tag',
  PAGE_IDENTITY: 'page_identity',
  UNGROUPED: 'ungrouped',
  UNGROUPED_PAGE_IDENTITY: 'ungrouped_page_identity',
  NEWSGUARD_RANK: 'newsguard_rank',
  PUBLICATION: 'publication'
}

export const Capabilities = {
  HAS_28_DAYS_EXPIRY: 'HAS_28_DAYS_EXPIRY',
  HAS_ADMINISTRATION_MODULE: 'HAS_ADMINISTRATION_MODULE',
  HAS_ALERTS_MODULE: 'HAS_ALERTS_MODULE',
  HAS_ADVERTISING_BANNER_FEATURE: 'HAS_ADVERTISING_BANNER_FEATURE',
  HAS_ANALYSIS_INFLUENCER_DETAILS_FEATURE: 'HAS_ANALYSIS_INFLUENCER_DETAILS_FEATURE',
  HAS_ANALYSIS_INFLUENCERS_MODULE: 'HAS_ANALYSIS_INFLUENCERS_MODULE',
  HAS_ANALYSIS_MODULE: 'HAS_ANALYSIS_MODULE',
  HAS_ANALYSIS_PUBLICATIONS_MODULE: 'HAS_ANALYSIS_PUBLICATIONS_MODULE',
  HAS_ANALYSIS_SAVED_SEARCHES_EDITING_FEATURE: 'HAS_ANALYSIS_SAVED_SEARCHES_EDITING_FEATURE',
  HAS_ANALYSIS_SAVED_SEARCHES: 'HAS_ANALYSIS_SAVED_SEARCHES',
  HAS_ANALYSIS_SAVED_SEARCHES_FEEDS: 'HAS_ANALYSIS_SAVED_SEARCHES_FEEDS',
  HAS_CONTACTS_MANAGEMENT_ANEWSTIP_API_KEY_EDITING_FEATURE: 'HAS_CONTACTS_MANAGEMENT_ANEWSTIP_API_KEY_EDITING_FEATURE',
  HAS_CONTACTS_MANAGEMENT_ANEWSTIP: 'HAS_CONTACTS_MANAGEMENT_ANEWSTIP',
  HAS_AUTOMATIC_SEARCH_RESULT_TRANSLATIONS: 'HAS_AUTOMATIC_SEARCH_RESULT_TRANSLATIONS',
  HAS_CHARTS_MODULE: 'HAS_CHARTS_MODULE',
  HAS_CUSTOM_TAG_ASSISTANT: 'HAS_CUSTOM_TAG_ASSISTANT',
  HAS_CUSTOM_TAG_RSS_EXPORT: 'HAS_CUSTOM_TAG_RSS_EXPORT',
  HAS_CUSTOM_TAGS: 'HAS_CUSTOM_TAGS',
  HAS_CUSTOM_TAGS_MODULE: 'HAS_CUSTOM_TAGS_MODULE',
  HAS_CUSTOM_TAG_XML_EXPORT: 'HAS_CUSTOM_TAG_XML_EXPORT',
  HAS_CUSTOM_TAG_JSON_EXPORT: 'HAS_CUSTOM_TAG_JSON_EXPORT',
  HAS_DASHBOARD_EDITING_FEATURE: 'HAS_DASHBOARD_EDITING_FEATURE',
  HAS_DASHBOARD_MODULE: 'HAS_DASHBOARD_MODULE',
  HAS_DASHBOARD_PUBLISHING_FEATURE: 'HAS_DASHBOARD_PUBLISHING_FEATURE',
  HAS_DELETE_NEWS_FEATURE: 'HAS_DELETE_NEWS_FEATURE',
  HAS_EDITING_DUMMY_MODULE: 'HAS_EDITING_DUMMY_MODULE',
  HAS_EDITING_FEATURE: 'HAS_EDITING_FEATURE',
  HAS_EDITING_FULLTEXT_FEATURE: 'HAS_EDITING_FULLTEXT_FEATURE',
  HAS_EXTERNAL_ACCOUNT_SETTINGS: 'HAS_EXTERNAL_ACCOUNT_SETTINGS',
  HAS_EXTERNAL_ANALYTICS: 'HAS_EXTERNAL_ANALYTICS',
  HAS_GLOBAL_SETTINGS: 'HAS_GLOBAL_SETTINGS',
  HAS_INFLUENCER_DETAILS_FEATURE: 'HAS_INFLUENCER_DETAILS_FEATURE',
  HAS_INFLUENCERS_MODULE: 'HAS_INFLUENCERS_MODULE',
  HAS_INFLUENCERS_XLSX_EXPORT: 'HAS_INFLUENCERS_XLSX_EXPORT',
  HAS_MAILING_LISTS: 'HAS_MAILING_LISTS',
  HAS_MEDIA_REVIEW_DISPATCH_FEATURE: 'HAS_MEDIA_REVIEW_DISPATCH_FEATURE',
  HAS_MEDIA_REVIEW_EDITING_FEATURE: 'HAS_MEDIA_REVIEW_EDITING_FEATURE',
  HAS_MEDIA_REVIEW_MODULE: 'HAS_MEDIA_REVIEW_MODULE',
  HAS_NEWS_MODULE: 'HAS_NEWS_MODULE',
  HAS_COPY_TO_CONTENT_MODULE_FEATURE: 'HAS_COPY_TO_CONTENT_MODULE_FEATURE',
  HAS_NEWS_POOL_DELETE_NEWS_FEATURE: 'HAS_NEWS_POOL_DELETE_NEWS_FEATURE',
  HAS_NEWS_POOL_EDITING_FEATURE: 'HAS_NEWS_POOL_EDITING_FEATURE',
  HAS_NEWS_POOL_EXPORT: 'HAS_NEWS_POOL_EXPORT',
  HAS_NEWS_POOL_INFLUENCER_DETAILS_FEATURE: 'HAS_NEWS_POOL_INFLUENCER_DETAILS_FEATURE',
  HAS_NEWS_POOL_INFLUENCERS_MODULE: 'HAS_NEWS_POOL_INFLUENCERS_MODULE',
  HAS_NEWS_POOL_INFLUENCERS_XLSX_EXPORT: 'HAS_NEWS_POOL_INFLUENCERS_XLSX_EXPORT',
  HAS_NEWS_POOL_MODULE: 'HAS_NEWS_POOL_MODULE',
  HAS_NEWS_POOL_PUBLICATIONS_MODULE: 'HAS_NEWS_POOL_PUBLICATIONS_MODULE',
  HAS_NEWS_POOL_PUBLICATIONS_XLSX_EXPORT: 'HAS_NEWS_POOL_PUBLICATIONS_XLSX_EXPORT',
  HAS_NEWS_POOL_SAVED_SEARCHES_EDITING_FEATURE: 'HAS_NEWS_POOL_SAVED_SEARCHES_EDITING_FEATURE',
  HAS_NEWS_POOL_SAVED_SEARCHES: 'HAS_NEWS_POOL_SAVED_SEARCHES',
  HAS_NEWS_POOL_SAVED_SEARCHES_FEEDS: 'HAS_NEWS_POOL_SAVED_SEARCHES_FEEDS',
  HAS_NEWS_SAVED_SEARCHES_EDITING_FEATURE: 'HAS_NEWS_SAVED_SEARCHES_EDITING_FEATURE',
  HAS_NEWS_SAVED_SEARCHES: 'HAS_NEWS_SAVED_SEARCHES',
  HAS_NEWS_SAVED_SEARCHES_FEEDS: 'HAS_NEWS_SAVED_SEARCHES_FEEDS',
  HAS_MOZ: 'HAS_MOZ',
  HAS_PROFILE_MONITORING_MODULE: 'HAS_PROFILE_MONITORING_MODULE',
  HAS_PROFILE_MONITORING_SAVED_SEARCHES_EDITING_FEATURE: 'HAS_PROFILE_MONITORING_SAVED_SEARCHES_EDITING_FEATURE',
  HAS_PROFILE_MONITORING_SAVED_SEARCHES: 'HAS_PROFILE_MONITORING_SAVED_SEARCHES',
  HAS_PROFILE_MONITORING_SAVED_SEARCHES_FEEDS: 'HAS_PROFILE_MONITORING_SAVED_SEARCHES_FEEDS',
  HAS_PUBLICATIONS_MODULE: 'HAS_PUBLICATIONS_MODULE',
  HAS_PUBLICATIONS_XLSX_EXPORT: 'HAS_PUBLICATIONS_XLSX_EXPORT',
  HAS_RTV_ORDER_FEATURE: 'HAS_RTV_ORDER_FEATURE',
  HAS_SHOPPING_CART: 'HAS_SHOPPING_CART',
  HAS_SUBSCRIPTIONS_MODULE: 'HAS_SUBSCRIPTIONS_MODULE',
  HAS_US_TUTORIALS: 'HAS_US_TUTORIALS',
  HAS_XML_EXPORT: 'HAS_XML_EXPORT',
  HAS_JSON_EXPORT: 'HAS_JSON_EXPORT',
  HAS_NEWSGUARD: 'HAS_NEWSGUARD',
  HAS_DARKNET_MODULE: 'HAS_DARKNET_MODULE',
  HAS_DARKNET_DASHBOARD: 'HAS_DARKNET_DASHBOARD',
  HAS_DARKNET_QUERY_MANAGER: 'HAS_DARKNET_QUERY_MANAGER',
  HAS_EXTERNAL_CONVENTO_LINK: 'HAS_EXTERNAL_CONVENTO_LINK',
  HAS_DISABLED_USER_SETTINGS: 'HAS_DISABLED_USER_SETTINGS',
  HAS_CONTENT_DESK_MODULE: 'HAS_CONTENT_DESK_MODULE',
  HAS_CONTENT_DESK_LINKED_IN: 'HAS_CONTENT_DESK_LINKED_IN',
  HAS_CONTENT_DESK_FACEBOOK: 'HAS_CONTENT_DESK_FACEBOOK',
  HAS_CONTENT_DESK_OTS_PR: 'HAS_CONTENT_DESK_OTS_PR',
  HAS_CONTACTS_MANAGEMENT_MODULE: 'HAS_CONTACTS_MANAGEMENT_MODULE',
  HAS_SAVED_CHARTS: 'HAS_SAVED_CHARTS',
  HAS_TRANSLATION_FEATURE: 'HAS_TRANSLATION_FEATURE',
  HAS_DISPATCH_LOG: 'HAS_DISPATCH_LOG',
  HAS_CONTENT_DESK_PUBLIC_TEMPLATES_READ_RIGHTS: 'HAS_CONTENT_DESK_PUBLIC_TEMPLATES_READ_RIGHTS',
  HAS_CONTENT_DESK_PUBLIC_TEMPLATES_WRITE_RIGHTS: 'HAS_CONTENT_DESK_PUBLIC_TEMPLATES_WRITE_RIGHTS',
  HAS_CONTENT_DESK_ALLOWED_DOMAINS_SETTINGS: 'HAS_CONTENT_DESK_ALLOWED_DOMAINS_SETTINGS',
  HAS_AI_SUMMARY_FEATURE: 'HAS_AI_SUMMARY_FEATURE',
  HAS_GAIO_MODULE: 'HAS_GAIO_MODULE',
  HAS_THE_MAX_MODULE: 'HAS_THE_MAX_MODULE',
  HAS_THE_MAX_PAID_VERSION: 'HAS_THE_MAX_PAID_VERSION',
  HAS_JOURNALISTS_MODULE: 'HAS_JOURNALISTS_MODULE',
  HAS_HOME_MODULE: 'HAS_HOME_MODULE',
  HAS_SUPPORT_MODULE: 'HAS_SUPPORT_MODULE'
}

export const ShoppingCartGroupBy = {
  CODE: 'code',
  CUSTOM_TAG: 'custom_tag',
  COUNTRY: 'country',
  CHANNEL: 'channel'
}

export const shoppingCartGroupLabelKey = groupBy => {
  if (groupBy === ShoppingCartGroupBy.CUSTOM_TAG) {
    return 'custom_tag'
  }

  if (groupBy === ShoppingCartGroupBy.COUNTRY) {
    return 'country'
  }

  if (groupBy === ShoppingCartGroupBy.CHANNEL) {
    return 'channel'
  }

  return 'topic'
}

export const AlertTriggerTypes = {
  NEW_HITS: 'new_hits',
  SCHEDULE: 'schedule',
  THRESHOLD: 'threshold',
  WITHOUT_CONDITION: 'without_condition'
}

export const AlertScheduleTypes = {
  INTERVAL: 'interval',
  CALENDAR: 'calendar'
}

export const AlertCheckTypes = {
  NEW_HITS: 'new_hits',
  THRESHOLD: 'threshold',
  WITHOUT_CONDITION: 'without_condition'
}

export const AlertActionTypes = {
  EMAIL: 'email',
  WEBHOOK: 'webhook'
}

export const AlertAttachmentTypes = {
  DASHBOARD_POWERPOINT: 'dashboard_powerpoint'
}

export const EmptyDashboardPowerpointAttachment = {
  type: AlertAttachmentTypes.DASHBOARD_POWERPOINT,
  data: {
    dashboardId: null,
    aiEnabled: false
  }
}

export const EmptyAlertContent = {
  includeNews: true,
  limit: 100,
  html: {
    forcePdfLink: false,
    clusterNews: true,
    groupBy: 'ungrouped',
    template: 'news_alert',
    dispatchConfigId: null,
    kpis: {
      showReach: true,
      showAve: false,
      showVisits: false,
      showCirculation: false,
      showDuration: true,
      showSentiment: false
    }
  },
  ai: {
    summary: {
      enabled: false,
      prompt: '',
      mode: 'backwards_search_exporter_default',
      additionalModes: []
    },
    overall: {
      enabled: false,
      integrateOnly: false
    }
  },
  attachments: []
}

export const EmptyAlertActionEmail = {
  type: AlertActionTypes.EMAIL,
  name: '',
  locale: 'de',
  savedSearchId: null,
  subject: '',
  recipients: [],
  mailingListIds: [],
  charts: [],
  content: EmptyAlertContent
}

export const EmptyAlertActionWebhook = {
  type: AlertActionTypes.WEBHOOK,
  name: '',
  locale: 'de',
  savedSearchId: null,
  url: '',
  charts: [],
  content: EmptyAlertContent
}

export const EmptyAlert = {
  enabled: true,
  name: '',
  nameEn: '',
  nameDe: '',
  nameFr: '',
  nameRu: '',
  nameZh: '',
  nameJa: '',
  nameIt: '',
  cursor: null,
  expiresAt: null,
  scheduledJobs: [],
  schedule: {
    type: AlertScheduleTypes.INTERVAL,
    interval: 'PT10M',
    timezone: 'Europe/Berlin',
    days: [1, 2, 3, 4, 5],
    activeWindows: []
  },
  condition: {
    savedSearchId: null,
    match: 'all',
    checks: [{ type: AlertCheckTypes.NEW_HITS }],
    ai: {
      filter: {
        enabled: false,
        prompt: ''
      }
    }
  },
  actions: [{ ...EmptyAlertActionEmail }]
}

export const EmptyAlertChart = {
  dataSource: 'pressrelations_news',
  dataSourceOpts: {
    savedSearchId: null,
    groupingType: null,
    sortBy: null
  },
  type: 'bar',
  bucket: 'channels',
  groupBy: null,
  metric: null,
  dateRange: 'last_7_days',
  dateFrom: null,
  dateTo: null,
  dateInterval: null,
  label: '',
  topLabel: null,
  description: null,
  chartOpts: {}
}

export const CustomTagAfterExportActions = {
  NONE: 'none',
  PURGE: 'purge',
  SUBSTITUTE: 'substitute'
}

export const NewsPageSize = 10
export const NewsPageMoreNewsSize = 50
export const ChartGridRowHeight = 95
export const ChartLimits = [3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]

export const StepTypes = {
  KPI: 'kpi',
  CHARTS: 'charts',
  TIMELINE: 'timeline',
  SAVED_SEARCHES_TIMELINE: 'saved_searches_timeline',
  NEWS_FEED: 'news_feed',
  TOP_INFLUENCERS: 'top_influencers',
  TOP_PUBLICATIONS: 'top_publications',
  PAGE_IDENTITIES_TIMELINE: 'page_identities_timeline',
  PAGE_IDENTITIES: 'page_identities',
  IMAGE_FEED: 'image_feed'
}

export const ChartDataSources = {
  PRESSRELATIONS_NEWS: 'pressrelations_news',
  GOOGLE_ANALYTICS: 'google_analytics',
  MOZ: 'moz',
  YOUTUBE_ANALYTICS: 'youtube_analytics',
  LINKED_IN_ANALYTICS: 'linked_in_analytics',
  FACEBOOK_ANALYTICS: 'facebook_analytics',
  TWITTER_ANALYTICS: 'twitter_analytics',
  IMAGE: 'image',
  TEXT: 'text',
  EXTERNAL_WIDGET: 'external_widget'
}

export const ChartTypes = {
  AREA: 'area',
  BAR: 'bar',
  BUBBLE: 'bubble',
  EXTERNAL_WIDGET: 'externalWidget',
  FUNNEL: 'funnel',
  GAUGE: 'gauge',
  HEATMAP: 'heatmap',
  HORIZONTAL_BAR: 'horizontalBar',
  IMAGE: 'image',
  IMAGE_FEED: 'imageFeed',
  INFLUENCER_FEED: 'influencerFeed',
  LINE: 'line',
  NEWS_FEED: 'newsFeed',
  NEWS_TICKER: 'newsTicker',
  PAGE_IDENTITY_FEED: 'pageIdentityFeed',
  PIE: 'pie',
  PUBLICATION_FEED: 'publicationFeed',
  RADAR: 'radar',
  RADIAL_BAR: 'radialBar',
  RECTANGLE: 'rectangle',
  SOCIAL_MEDIA_ANALYTICS_FEED: 'socialMediaAnalyticsFeed',
  SOCIAL_MEDIA_ANALYTICS_STORIES_FEED: 'socialMediaAnalyticsStoriesFeed',
  STATE_MAP: 'stateMap',
  SUNBURST: 'sunburst',
  TAG_CLOUD: 'tagCloud',
  TEXT: 'text',
  TREEMAP: 'treemap',
  WORLD_MAP: 'worldMap'
}

export const CookieNames = {
  NEWSRADAR: 'groot_newsradar',
  NAVIGATION_LOCKED: 'groot_navigation_locked',
  INITIAL_ROUTE: 'groot_initial_route',
  SESSION: 'groot_session',
  ACCESS_TOKEN: 'groot_access_token',
  COOKIES_ACCEPTED: 'groot_cookies_accepted'
}

export const DateModes = {
  DATE_RANGE: 'date_range',
  DATE: 'date',
  RELATIVE: 'relative'
}

export const Networks = [
  { name: 'Onion', id: 'onion', forDarkowlSearchQuery: true },
  { name: 'Telegram', id: 'telegram', forDarkowlSearchQuery: true },
  { name: 'I2P', id: 'i2p', forDarkowlSearchQuery: true },
  { name: 'Discord', id: 'discord', forDarkowlSearchQuery: true },
  { name: 'Zeronet', id: 'zeronet', forDarkowlSearchQuery: true },
  { name: 'FTP', id: 'ftp', forDarkowlSearchQuery: true },
  { name: 'IRC', id: 'irc', forDarkowlSearchQuery: true },
  { name: 'OpenNIC', id: 'openNIC', forDarkowlSearchQuery: true },
  { name: 'Unclassified', id: 'unclassified', forDarkowlSearchQuery: false }
]

export const Intervals = {
  hourly: 60,
  twice_a_day: 720,
  daily: 1440,
  twice_a_week: 5040,
  weekly: 10080,
  monthly: 40320
}

export const DateRanges = [
  'today',
  'yesterday',
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_quarter',
  'last_quarter',
  'this_half_year',
  'last_half_year',
  'this_year',
  'last_year',
  'last_6_months',
  'last_12_months',
  'last_7_days',
  'last_30_days',
  'last_60_days',
  'last_90_days',
  'last_12_hours',
  'last_24_hours'
]

export const SortingOptions = [
  '',
  'reach',
  'interactions'
]

export const StructuredExportFormatFlags = ['rssEnabled', 'xmlEnabled', 'jsonEnabled']

export const ContentDeskSearchFields = {
  CONTENT_PLAIN_TEXT: 'content_plain_text',
  CONTENT_TITLE: 'content_title',
  CAMPAIGN_NAME: 'campaign_name'
}

export const ContactManagementContactsDataGridColumnVisibility = {
  DEFAULT: {
    firstName: true,
    lastName: true,
    email: true,
    country: true,
    publication: true,
    supplier: true,
    languages: true,
    distributionLists: true,
    createdAt: true,
    updatedAt: true
  }
}

export const ContactManagementDistributionListsDataGridColumnVisibility = {
  DEFAULT: {
    name: true,
    description: true,
    contacts: true,
    createdAt: true,
    updatedAt: true,
    actions: true
  }
}

export const ThemaxSearchFields = {
  TOPIC_PLAN: 'topic_plan',
  PUBLICATION_NAME: 'publication_name',
  PUBLICATION_INFO: 'publication_info',
  REACH_MIN: 'reachMin',
  REACH_MAX: 'reachMax',
  PAGE_AVE_MIN: 'pageAveMin',
  PAGE_AVE_MAX: 'pageAveMax',
  BOOKMARKED_ONLY: 'bookmarkedOnly',
  PUBLICATION: 'publication'
}

export const LicensersWithDisabledArticleDateEditing = [20]
export const LicensersWithDisabledMediaReviewDateEditing = [9]

export const Countries = {
  AUT: 40,
  CHE: 756,
  DEU: 276,
  IRL: 372,
  USA: 840,
  FRA: 250,
  ITA: 380
}

export const CdEditorMoods = [
  { id: 1, label: 'optimistic but not exaggerated' },
  { id: 2, label: 'pessimistic but not exaggerated' },
  { id: 3, label: 'humorous' },
  { id: 4, label: 'inspiring' },
  { id: 5, label: 'casual' },
  { id: 6, label: 'dramatic' },
  { id: 7, label: 'romantic' },
  { id: 8, label: 'urgent' },
  { id: 9, label: 'nostalgic' },
  { id: 10, label: 'cautious' },
  { id: 11, label: 'apologetic' },
  { id: 12, label: 'reassuring' },
  { id: 13, label: 'provocative' },
  { id: 14, label: 'passionate' }
]

export const CurrentTypeformSurveyId = 'LasNKD9q'

export const UploadedMediaFilesSizeLimit = 524288000 // 500 MB
export const UploadedMediaSingleFileSizeLimit = 5000000 // 5 MB

export const LanguageOptions = [
  {
    languageId: 1,
    languageShort: 'de',
    countryCode: 'de',
    localeMapping: {}
  },
  {
    languageId: 2,
    languageShort: 'en',
    countryCode: 'us',
    localeMapping: {
      'en-us': 'us',
      'en-ca': 'ca',
      'en-gb': 'gb',
      'en-ie': 'ie'
    }
  },
  {
    languageId: 4,
    languageShort: 'fr',
    countryCode: 'fr',
    localeMapping: {}
  },
  {
    languageId: 8,
    languageShort: 'it',
    countryCode: 'it',
    localeMapping: {}
  },
  {
    languageId: 5,
    languageShort: 'ru',
    countryCode: 'ru',
    localeMapping: {}
  },
  {
    languageId: 6,
    languageShort: 'zh',
    countryCode: 'cn',
    localeMapping: {}
  },
  {
    languageId: 7,
    languageShort: 'ja',
    countryCode: 'jp',
    localeMapping: {}
  }
]

export const ThemaxReachFilterOptions = {
  min: 0,
  max: 30000000,
  marks: [
    {
      value: 0,
      scaledValue: 0,
      label: '0'
    },
    {
      value: 25,
      scaledValue: 100000,
      label: '100k'
    },
    {
      value: 50,
      scaledValue: 1000000,
      label: '1M'
    },
    {
      value: 75,
      scaledValue: 10000000,
      label: '10M'
    },
    {
      value: 100,
      scaledValue: 30000000,
      label: '30M'
    }
  ]
}

export const ThemaxPageAveFilterOptions = {
  min: 0,
  max: 1000000,
  marks: [
    {
      value: 0,
      scaledValue: 0,
      label: '0'
    },
    {
      value: 25,
      scaledValue: 10000,
      label: '10k'
    },
    {
      value: 50,
      scaledValue: 50000,
      label: '50k'
    },
    {
      value: 75,
      scaledValue: 500000,
      label: '500k'
    },
    {
      value: 100,
      scaledValue: 1000000,
      label: '1M'
    }
  ]
}

export const ExcelMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

// https://api.docs.analytics.dev.naplatform.de/#get-/integrationpartner/orders/-orderId-
export const OtsStatuses = {
  DRAFT: 'DRAFT',
  REVIEW: 'REVIEW',
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
  DISTRIBUTED: 'DISTRIBUTED'
}

export const UnlayerEmailEditor = {
  version: '1.52.0',
  defaultProjectId: 162808,
  customProjectId: 156689,
  defaultScriptUrl: 'https://editor.unlayer.com/embed.js?2',
  customScriptUrl: 'https://fukomys.pressrelations.de/'
}

export const forbiddenQueryPatterns = [
  {
    pattern: /^\*+$/,
    allowedCount: 0
  },
  {
    pattern: /^-\S+$/,
    allowedCount: 0
  },
  {
    pattern: /^NOT \S+$/,
    allowedCount: 0
  }
]

export const AiConfig = {
  maxAiAnalysisCompanyDescriptionLength: 2000,
  maxAiAnalysisInstructionsLength: 2000
}

export const NotInvertibleFilters = [
  SearchFields.BOOLEANS,
  SearchFields.AUTHOR_QUERIES,
  SearchFields.GEO_BOUNDING_BOX,
  SearchFields.OUTLINK_URLS,
  SearchFields.OUTLINKS,
  SearchFields.SIMILARITY_CCD_CONTENTS,
  SearchFields.SIMILARITY_CCD_CAMPAIGNS,
  DarknetSearchFields.MIN_HACKISHNESS,
  ContentDeskSearchFields.CONTENT_PLAIN_TEXT,
  ContentDeskSearchFields.CONTENT_TITLE,
  ContentDeskSearchFields.CAMPAIGN_NAME,
  ThemaxSearchFields.REACH_MIN,
  ThemaxSearchFields.REACH_MAX,
  ThemaxSearchFields.PAGE_AVE_MIN,
  ThemaxSearchFields.PAGE_AVE_MAX
]

export const EditableFilters = [
  SearchFields.NEWS_QUERIES,
  SearchFields.PUBLICATION_QUERIES,
  SearchFields.AUTHOR_QUERIES,
  DarknetSearchFields.DARKNET_SEARCH_QUERIES,
  ContentDeskSearchFields.CONTENT_PLAIN_TEXT,
  ContentDeskSearchFields.CONTENT_TITLE,
  ContentDeskSearchFields.CAMPAIGN_NAME,
  ThemaxSearchFields.TOPIC_PLAN,
  ThemaxSearchFields.PUBLICATION_NAME,
  ThemaxSearchFields.PUBLICATION_INFO
]

export const AllSettings = [
  { value: 'personal_settings', capability: Capabilities.HAS_DISABLED_USER_SETTINGS },
  { value: 'settings', capability: Capabilities.HAS_GLOBAL_SETTINGS },
  { value: 'content_desk_settings', capability: Capabilities.HAS_CONTENT_DESK_MODULE },
  { value: 'my_news', capability: Capabilities.HAS_SUBSCRIPTIONS_MODULE },
  { value: 'mailing_list', capability: Capabilities.HAS_MAILING_LISTS },
  { value: 'dispatch_log', capability: Capabilities.HAS_DISPATCH_LOG },
  { value: 'saved_charts', capability: Capabilities.HAS_SAVED_CHARTS },
  { value: 'external_accounts', capability: Capabilities.HAS_EXTERNAL_ACCOUNT_SETTINGS },
  { value: 'gaio_subscriptions', capability: Capabilities.HAS_GAIO_MODULE },
  { value: 'persona_library', capability: Capabilities.HAS_GAIO_MODULE }
]

export const SettingsBasePath = '/app/settings'

export const getSettingsPath = tab => `${SettingsBasePath}/${tab}`

export const MonitoringModules = [
  {
    name: 'news_board',
    capability: Capabilities.HAS_NEWS_MODULE,
    path: '/app/news',
    description: 'home_news_board_description',
    shortDescription: 'home_news_board_short_description',
    feature1: 'home_news_board_feature_1',
    feature2: 'home_news_board_feature_2',
    feature3: 'home_news_board_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/iismnibplmny?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/jg0lww1igy1c?embed=inline',
    featureDescription1: 'home_news_board_feature_1_description',
    featureDescription2: 'home_news_board_feature_2_description',
    featureDescription3: 'home_news_board_feature_3_description'
  },
  {
    name: 'profile_monitoring',
    capability: Capabilities.HAS_PROFILE_MONITORING_MODULE,
    path: '/app/profile_monitoring',
    description: 'home_profile_monitoring_description',
    shortDescription: 'home_profile_monitoring_short_description',
    feature1: 'home_profile_monitoring_feature_1',
    feature2: 'home_profile_monitoring_feature_2',
    feature3: 'home_profile_monitoring_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/hrtzdwettafg?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/4sgcs2dam3hw?embed=inline',
    featureDescription1: 'home_profile_monitoring_feature_1_description',
    featureDescription2: 'home_profile_monitoring_feature_2_description',
    featureDescription3: 'home_profile_monitoring_feature_3_description'
  },
  {
    name: 'search_pool',
    capability: Capabilities.HAS_NEWS_POOL_MODULE,
    path: '/app/search_pool',
    description: 'home_search_pool_description',
    shortDescription: 'home_search_pool_short_description',
    feature1: 'home_search_pool_feature_1',
    feature2: 'home_search_pool_feature_2',
    feature3: 'home_search_pool_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/qsntyfhm0joh?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/9dfd949brplf?embed=inline',
    featureDescription1: 'home_search_pool_feature_1_description',
    featureDescription2: 'home_search_pool_feature_2_description',
    featureDescription3: 'home_search_pool_feature_3_description'
  },
  {
    name: 'media_reviews_menu',
    capability: Capabilities.HAS_MEDIA_REVIEW_MODULE,
    path: '/app/media_reviews',
    description: 'home_media_reviews_description',
    shortDescription: 'home_media_reviews_short_description',
    feature1: 'home_media_reviews_feature_1',
    feature2: 'home_media_reviews_feature_2',
    feature3: 'home_media_reviews_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/jbb2nubpgazu?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/qskkkkllebov?embed=inline',
    featureDescription1: 'home_media_reviews_feature_1_description',
    featureDescription2: 'home_media_reviews_feature_2_description',
    featureDescription3: 'home_media_reviews_feature_3_description'
  },
  {
    name: 'alerts',
    capability: Capabilities.HAS_ALERTS_MODULE,
    path: '/app/alerts',
    shortDescription: 'alerts_short_description'
  }
]

export const PrModules = [
  {
    name: 'content_desk',
    capability: Capabilities.HAS_CONTENT_DESK_MODULE,
    path: '/app/content_desk/content_management',
    description: 'home_content_desk_description',
    shortDescription: 'home_content_desk_short_description',
    feature1: 'home_content_desk_feature_1',
    feature2: 'home_content_desk_feature_2',
    feature3: 'home_content_desk_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/flklddopheig?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/r5p7lpq35jea?embed=inline',
    featureDescription1: 'home_content_desk_feature_1_description',
    featureDescription2: 'home_content_desk_feature_2_description',
    featureDescription3: 'home_content_desk_feature_3_description'
  },
  {
    name: 'contact_management',
    capability: Capabilities.HAS_CONTACTS_MANAGEMENT_MODULE,
    path: '/app/contact_management/contacts',
    description: 'home_contact_management_description',
    shortDescription: 'home_contact_management_short_description',
    feature1: 'home_contact_management_feature_1',
    feature2: 'home_contact_management_feature_2',
    feature3: 'home_contact_management_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/rcgahtkzesja?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/vxhwc2rsapoz?embed=inline',
    featureDescription1: 'home_contact_management_feature_1_description',
    featureDescription2: 'home_contact_management_feature_2_description',
    featureDescription3: 'home_contact_management_feature_3_description'
  },
  {
    name: 'journalist_search',
    capability: Capabilities.HAS_JOURNALISTS_MODULE,
    path: '/app/contact_management/journalists',
    description: 'home_journalist_search_description',
    shortDescription: 'home_journalist_search_short_description',
    feature1: 'home_journalist_search_feature_1',
    feature2: 'home_journalist_search_feature_2',
    feature3: 'home_journalist_search_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/10reim1t083c?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/ujrqmrjaeozg?embed=inline',
    featureDescription1: 'home_journalist_search_feature_1_description',
    featureDescription2: 'home_journalist_search_feature_2_description',
    featureDescription3: 'home_journalist_search_feature_3_description'
  },
  {
    name: 'themax',
    capability: Capabilities.HAS_THE_MAX_MODULE,
    path: '/app/themax',
    description: 'home_themax_description',
    shortDescription: 'home_themax_short_description',
    feature1: 'home_themax_feature_1',
    feature2: 'home_themax_feature_2',
    feature3: 'home_themax_feature_3',
    enDemoUrl: 'https://app.storylane.io/demo/nvxxl2cv6jxy?embed=inline',
    deDemoUrl: 'https://app.storylane.io/demo/gvrt7gsdvjnk?embed=inline',
    featureDescription1: 'home_themax_feature_1_description',
    featureDescription2: 'home_themax_feature_2_description',
    featureDescription3: 'home_themax_feature_3_description'
  }
]
